export type Locale = (typeof locales)[number]

export const locales = ['en-US', 'zh-TW', 'ja-JP'] as const
export const DEFAULT_LOCALE: Locale = 'en-US'
export const LANG_CODE_KEY = '_htc_lang_code'
export const NEXT_LOCALE_KEY = 'NEXT_LOCALE'
export const LANG_CODE_COOKIE_DOMAIN = '.viverse.com'
export const ONE_YEAR = 365 * 24 * 60 * 60 * 1000
